<ion-content class="ion-align-items-center ion-justify-content-center content-class">
  <!--<a href="http://www.freepik.com">Designed by starline / Freepik</a>-->
  <ion-grid class="bg-transparent">
    <ion-row *ngIf="versionLoading == false">
      <ion-col size-zs="0"></ion-col>
      <ion-col size="12" class="tarjet">
        <ion-row>
          <ion-col class="vertical">
            <div class="headerText"><b>Mando de subasta</b></div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="vertical">
            <ion-img class="headerImg" src="assets/logos/logo_1.png"></ion-img>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="latestVersion && storageService.isWeb == false && version != latestVersion">
          <ion-col size="12" class="ion-no-padding">
            <ion-row>
              <ion-col size="12" class="ion-no-padding vertical">
                <span class="text-update">
                  Nueva versión disponible. Se requiere la última versión para acceder a funciones de la subasta.
                </span>
              </ion-col>
            </ion-row>
            <ion-row class="new-version" *ngIf="storageService.isIOS == true">
              <ion-col size="12" class="ion-no-padding vertical font-medium">
                <ion-label><strong>Revise la Apple Store para actualizar.</strong></ion-label>
              </ion-col>
            </ion-row>
            <ion-row class="new-version" (click)="getNewVersion()" *ngIf="storageService.isIOS != true">
              <ion-col size="2" class="ion-no-padding vertical">
                <div class="bounce2">
                  <fa-icon [icon]="faService.faDownload"></fa-icon>
                </div>
              </ion-col>
              <ion-col size="10" class="ion-no-padding vertical font-medium">
                <ion-label>Descargar versión <strong>{{latestVersion}}</strong></ion-label>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" class="ion-no-padding">
            <ion-row justify-content-center>
              <ion-col align-self-center size-md="12" size-lg="12" size-xl="12" size-xs="12" class="ion-text-left">
                <ion-row>
                  <ion-col size="12" class="ion-no-padding ion-text-center">
                    <fa-icon [icon]="faService.faUsers" style="margin-right: 5px;"></fa-icon>
                    Identificación de usuario
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12" class="ion-no-padding">
                    <ion-item>
                      <ion-label position="stacked" class="tituloLabel">Usuario</ion-label>
                      <ion-input label="" type="text" name="usuario" [(ngModel)]="username"
                        placeholder="Añada usuario...">
                      </ion-input>
                    </ion-item>
                    <ion-item>
                      <ion-label position="stacked" class="tituloLabel">Contraseña</ion-label>
                      <ion-input label="" [type]="showPassword ? 'text' : 'password'" name="password"
                        [(ngModel)]="password" placeholder="Añada contraseña..."
                        (keyup.enter)="validarUsuario()"></ion-input>
                      <!--<ion-icon [name]="showPassword ? 'eye' : 'eye-off'" (click)="toggleShowPass()"></ion-icon>-->
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12" class="ion-text-center ion-no-padding">
                    <ion-label class="mensajeError">{{error}}</ion-label>
                  </ion-col>
                </ion-row>
                <ion-row *ngIf="!politicaCheck">
                  <ion-col size="12" class="ion-text-center ion-no-padding verticalLeft">
                    <mat-checkbox color="primary"  (change)="changePolitica($event)" >
                      <ion-label >He leído y acepto la <a (click)="openPdf()" target="_system">política de privacidad.</a></ion-label>
                    </mat-checkbox>
                  </ion-col>
                </ion-row>
                <ion-row style="margin-top: 10px; margin-bottom: 10px;">
                  <ion-col size="12" class="ion-no-padding verticalLeft">
                    <mat-checkbox color="primary"  (change)="checkChange($event)" [(ngModel)]="checked">
                      Recordar mis datos de usuario
                    </mat-checkbox>
                  </ion-col>
                </ion-row>
                <ion-row style="margin-top: 20px">
                  <ion-col size="12" class="ion-no-padding ion-text-center">
                    <ion-button [disabled]="loginLoading == true" size="large" (click)="validarUsuario()" expand="block"
                      fill="solid" class="font-big login-button">Continuar
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-md="12" size-lg="12" size-xl="12" size-xs="12" class="ion-text-center">
                <div padding class="ion-text-center vertical">
                  <ion-button fill="clear" color="primary" (click)="recuperarContrasenha()">
                    Recuperar contraseña
                  </ion-button>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="showExtraLogos">
          <ion-col class="vertical" size="6">
            <ion-img src="assets/logos/xunta-azul.png" (ionError)="logoLoadError($event)" class="img-logo"></ion-img>
          </ion-col>
          <ion-col class="vertical" size="6">
            <ion-img src="assets/logos/FEMP.png" (ionError)="logoLoadError($event)" class="img-logo"></ion-img>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-no-padding">
            <span class="text-version">{{version}}</span>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col size-zs="0"></ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
